import CastFlowAIWorkspace from '../casting/CastFlowAIWorkspace';

export default function AdminCastingIngestPanel({ onClose }) {
  return <CastFlowAIWorkspace mode="admin" onClose={onClose} />;
}
